var _path, _path2, _path3;

function _extends() { _extends = Object.assign ? Object.assign.bind() : function (target) { for (var i = 1; i < arguments.length; i++) { var source = arguments[i]; for (var key in source) { if (Object.prototype.hasOwnProperty.call(source, key)) { target[key] = source[key]; } } } return target; }; return _extends.apply(this, arguments); }

import * as React from "react";

function SvgIconCovidEmergency(props) {
  return /*#__PURE__*/React.createElement("svg", _extends({
    width: 32,
    height: 32,
    viewBox: "0 0 32 32",
    fill: "none",
    xmlns: "http://www.w3.org/2000/svg"
  }, props), /*#__PURE__*/React.createElement("path", {
    fillRule: "evenodd",
    clipRule: "evenodd",
    d: "M10.794 7.548L9.5 2.718l1.932-.517 1.294 4.83-1.932.517zM17.506 7.03L18.8 2.2l1.932.518-1.294 4.83-1.932-.518zM22.965 10.536L26.5 7l1.414 1.414-3.535 3.536-1.415-1.414zM2.464 8.414L6 11.95l1.414-1.414L3.88 7 2.464 8.414z",
    fill: props.color
  }), _path || (_path = /*#__PURE__*/React.createElement("path", {
    d: "M7 17a8 8 0 1116 0v7.5H7V17z",
    fill: "#EDF2E9"
  })), /*#__PURE__*/React.createElement("path", {
    fillRule: "evenodd",
    clipRule: "evenodd",
    d: "M21 22.5V17a6 6 0 00-12 0v5.5h12zM15 9a8 8 0 00-8 8v7.5h16V17a8 8 0 00-8-8z",
    fill: props.color
  }), /*#__PURE__*/React.createElement("path", {
    fillRule: "evenodd",
    clipRule: "evenodd",
    d: "M23 24.5H7V28h16v-3.5zm-16-2a2 2 0 00-2 2V28a2 2 0 002 2h16a2 2 0 002-2v-3.5a2 2 0 00-2-2H7zM14.99 13.858a1 1 0 01-.848 1.132 1.953 1.953 0 00-1.652 1.652 1 1 0 01-1.98-.284 3.954 3.954 0 013.348-3.348 1 1 0 011.132.848z",
    fill: props.color
  }), _path2 || (_path2 = /*#__PURE__*/React.createElement("path", {
    fill: "#fff",
    d: "M21 21h8v8h-8z"
  })), _path3 || (_path3 = /*#__PURE__*/React.createElement("path", {
    fillRule: "evenodd",
    clipRule: "evenodd",
    d: "M29.242 20.757a6 6 0 10-8.486 8.487 6 6 0 008.486-8.487zM23.714 28l-2.384-2.384 1.212-1.212 1.172 1.172 3.532-3.532 1.212 1.212L23.714 28z",
    fill: "#54822B"
  })));
}

export default SvgIconCovidEmergency;